module.exports = __webpack_public_path__ + "img/22c)(Hotel Fürstenhof)Montage von über 100 Gästezimmer.jpg";